import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntry} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY_FILTER_CS} from '../../brand'

export const useGetMainMenu = (prefix = '') => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getMainMenu = async () => {
        const response = await getEntry({
            stack,
            contentTypeUid: `${prefix}mainmenu`,
            locale: locale.alias,
            brand: BRAND_KEY_FILTER_CS,
        })
        return response ? response[0] : null
    }

    const query = useQuery(['mainmenu', prefix], () => getMainMenu())

    return query
}
